import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';
const SvgUserSearch = ({
  alt = 'User Search Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <path
      fill="currentColor"
      d="M8.401 11.998a4.802 4.802 0 0 0 4.8-4.799 4.798 4.798 0 0 0-4.8-4.799 4.802 4.802 0 0 0-4.8 4.799 4.798 4.798 0 0 0 4.8 4.799Zm-1.714 1.8A6.684 6.684 0 0 0 0 20.48c0 .615.499 1.114 1.114 1.114h14.574c.615 0 1.114-.499 1.114-1.114v-.086a5.998 5.998 0 0 1-5.974-6.56 6.395 6.395 0 0 0-.713-.038H6.687Zm10.115-2.396a3.002 3.002 0 0 1 3 2.999 2.997 2.997 0 0 1-3 2.999 3 3 0 0 1-2.121-5.12 3.001 3.001 0 0 1 2.121-.878Zm0 7.797a4.788 4.788 0 0 0 2.697-.828l2.967 2.965a.9.9 0 0 0 1.271-1.27L20.77 17.1a4.8 4.8 0 0 0-3.972-7.494 4.8 4.8 0 1 0 0 9.597l.004-.004Z"
    />
  </svg>
);
export default SvgUserSearch;
